document.addEventListener('DOMContentLoaded', function () {

  /* ========= Collection: Mobile Slider ========= */
  if (window.innerWidth <= 749) {
    (function () {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          if (el._swInit) return;
          el._swInit = true;
          (function init() {
            if (!window.Swiper) { return void requestAnimationFrame(init); }
            new Swiper(el, {
              slidesPerView: 1,
              spaceBetween: 0,
              loop: false,
              speed: 400,
              grabCursor: true,
            });
          })();
        });
      }, { rootMargin: '300px 0px' });
      document.querySelectorAll('.mobile-product-swiper').forEach(function (el) { io.observe(el); });
    })();
  }

  /* ========= MOVE MID ROLL BANNER ========= */
  function moveMidRollBanner() {
    var $bannerSection = $('.rc-mid-roll-banner');
    if (!$bannerSection.length || $bannerSection.hasClass('banner-moved')) return;

    var isMobile = window.innerWidth <= 767;
    var insertAfter = isMobile ? 5 : 7;
    if (currentCollectionId === '301336658008') insertAfter = isMobile ? 5 : 3;
    if (currentCollectionId === '310079848536') insertAfter = 5;
    if (currentCollectionId === '312891801688') insertAfter = 5;

    var $productItems = $('.content-list > .grid-item:not(.collection-breaker-card):not(.rc-promo-grid-card):not(.static-img-shop-the-look-wrapper)');
    if ($productItems.length <= insertAfter) return;

    var $wrapper = $('<li class="grid-item collection-breaker-card collection-breaker-full"></li>');
    $wrapper.append($bannerSection);
    $productItems.eq(insertAfter).after($wrapper);
    $bannerSection.addClass('banner-moved');
  }

  setTimeout(moveMidRollBanner, 300);
  document.addEventListener('shopify:section:load', function () {
    setTimeout(moveMidRollBanner, 300);
  });

});

function initProductSliderCollection(){
  /* ========= Collection: Mobile Slider ========= */
  const isMobile = window.innerWidth <= 749 && window.matchMedia('(max-width: 749px)').matches;
  if (!isMobile) return;

  const isCollectionOrSearchPage = document.body.classList.contains('template-collection') || document.body.classList.contains('template-search') || document.body.dataset.template === 'collection' || document.body.dataset.template === 'search' || /^\/(collections|search)(\/|$|\?)/.test(window.location.pathname);

  if (!isCollectionOrSearchPage) return;

  if (window.innerWidth <= 749) {
    (function () {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          if (el._swInit) return;
          el._swInit = true;
          (function init() {
            if (!window.Swiper) { return void requestAnimationFrame(init); }
            new Swiper(el, {
              slidesPerView: 1,
              spaceBetween: 0,
              loop: false,
              speed: 400,
              grabCursor: true,
            });
          })();
        });
      }, { rootMargin: '300px 0px' });
      document.querySelectorAll('.mobile-product-swiper').forEach(function (el) { io.observe(el); });
    })();
  }
}

$(document).on('click', '.card-media.media', function (e) {
  const card = $(this).closest('.product-card-wrapper');
  const url = card.find('.card-heading a').attr('href');
  if (url) {
    window.location.href = url;
  }
});
